export default __webpack_public_path__ + "static/GlenOstergaard-3b7af98d1cdfd738c63278b7620e8cef.png";